import { onboarding } from '@services';

interface ITemplateRequest {
  studioId: string;
}

const downloadCsvTemplate = async ({
  studioId,
}: ITemplateRequest): Promise<BlobPart> => {
  const { data } = await onboarding.get<BlobPart>(
    `/api/v1/file/template?studioId=${studioId}`,
    {
      responseType: 'blob',
    },
  );
  return data;
};

const downloadXlsxTemplate = async ({
  studioId,
}: ITemplateRequest): Promise<BlobPart> => {
  const { data } = await onboarding.get<BlobPart>(
    `/api/v1/file/template/xlsx?studioId=${studioId}`,
    {
      responseType: 'blob',
    },
  );

  return data;
};

export { downloadCsvTemplate, downloadXlsxTemplate };
